import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import Underscore from 'underscore';

import * as actionTypes from './../../store/actions/productsAction';
import fetchProductsAction from './../../store/actions/fetch/fetchProductsAction';
import fetchLifeStageMappingAction from './../../store/actions/fetch/fetchLifeStageMappingAction';
import Loader from './../../components/Loader/Loader';
import ProductsSwitcher from './../../components/ProductSwitcher/ProductSwitcher';
import * as productTypes from './ProductsValues';
import ProductCardsRemover from "../../components/ProductCardsRemover/ProductCardsRemover";
import moment from 'moment';
import * as helpActionTypes from './../../store/actions/helpAction';

/**
 * Products container
 */
class Products extends Component {

  /**
   * Default values if species updated
   */
  shouldComponentUpdate(nextProps, nextState) {
    const {defaultValues, selectedAnimalType, availableCategories, setAvailableCategories} = this.props;
    if (selectedAnimalType !== nextProps.selectedAnimalType) {
      defaultValues(nextProps.selectedAnimalType);
    }

    // if (availableCategories.length !== nextProps.availableCategories.length) {
    //   setAvailableCategories(nextProps.availableCategories);
    // }

    return true;
  }

  /**
   * Fetch
   */
  componentDidMount() {
    const {fetchData, fetchMappingData} = this.props;
    fetchData();
    fetchMappingData();
  }

  /**
   * Select the inactive products (not possible to choose them).
   * User can add max 1 wet, 1 dry, 2 related, 2 snacks
   */
  getGreyed() {
    const {selectedData} = this.props;
    const selectedProducts = Object.values(selectedData);
    let greyed = {};
    for (const product of selectedProducts) {
      let productType = product.types[0];
      if(productType in greyed){
        greyed[productType] += 1;
      }
      else{
        greyed[productType] = 1;
      }
    }
    greyed[productTypes.DRY_FOOD] = productTypes.DRY_FOOD in greyed && greyed[productTypes.DRY_FOOD] > 0;
    greyed[productTypes.WET_FOOD] = productTypes.WET_FOOD in greyed && greyed[productTypes.WET_FOOD] > 0;
    greyed[productTypes.RELATED] = productTypes.RELATED in greyed && greyed[productTypes.RELATED] > 1;
    greyed[productTypes.SNACKS] = productTypes.SNACKS in greyed && greyed[productTypes.SNACKS] > 1;

    return greyed;
  }

  /**
   * Get all indications from diagnoses and activity
   */
  getAllIndications(){
    const {speciesId, birth, pregnancyId, lactationId, derData, dataMapping,
      selectedBreedData, selectedAnimalType, diagnoses, activityData,
      selectedDuration, selectedIntensity
    } = this.props;

    const activityIndications = activityData.data[selectedAnimalType][selectedDuration][selectedIntensity];
    let allIndications = [];
    if(activityIndications){
      allIndications = allIndications.concat(activityIndications);
    }
    allIndications = allIndications.concat(diagnoses);

    return allIndications;
  }

  /**
   * Helping function for filtering the products.
   * Products have to:
   * 1) be from selected range,
   * 2) match the species,
   * 3) match selected tab (dry, wet, related, snacks),
   * 4) do not have selected indication in contraindications
   */
  static checkProduct(selectedDiet, selectedAnimalType, selectedBreedData, selectedCategory, indications, derData, birth, product) {
    // Product range
    let productRange;
    if(selectedDiet.length === 0) {
      productRange  = true;
    } else{
      productRange = Underscore.intersection(product.ranges, selectedDiet).length > 0;
    }

    let less;
    const birthDate = moment(birth, 'DD/MM/YYYY').toDate();
    const weeksAge = Math.floor((new Date() - birthDate) / 604800000)
    if (derData.lifeStage === 'growth' && weeksAge && (less = product?.customContraindications?.find(i => i.includes('less_')))) {
      const lessWeeks = less.replace('less_', '')
      if (weeksAge < lessWeeks) {
        return false;
      }
    }

    // Species
    let species = false;
    if(product.breed[selectedAnimalType].length > 0){
      species = true;
    }
    // Tab
    const category = product.types.includes(selectedCategory);

    // Contraindication
    const checkIndications = Underscore.intersection(product.contraindications, indications).length === 0;

    // Size
    const sizeRecommended = product.breed[selectedAnimalType].includes(selectedBreedData.sizeId) > 0;

    if (
      (product?.customContraindications?.includes("adult") && product?.customContraindications?.includes("senior")) &&
      (derData.casuistic === "lactation" || derData.casuistic === "pregnancy") &&
      (productRange && species && category && checkIndications && sizeRecommended)
    ) {
        return true;
    }

    if (
      product?.customContraindications?.includes(derData.lifeStage)
        || product?.customContraindications?.includes(derData.casuistic)
    ) {
      return false;
    }

    // Return
    return productRange && species && category && checkIndications && sizeRecommended;
  }

  /**
   * Filter products. It uses helping function checkProduct.
   */
  getFilteredProducts(foodCategory){
    const {data, selectedDietData, selectedBreedData, selectedAnimalType, selectedCategory, derData, birth} = this.props;
    let diets = [];
    Object.keys(selectedDietData).map((key) => {
        diets.push(parseInt(key));
    });
    const indications = this.getAllIndications();
    return data.data.filter(Products.checkProduct.bind(
      null,
      diets,
      selectedAnimalType,
      selectedBreedData,
      foodCategory ? foodCategory : selectedCategory,
      indications,
      derData,
      birth,
    ));
  }

  getPoints(product, pointsReport){
    const {speciesId, birth, pregnancyId, lactationId, derData, dataMapping,
      selectedBreedData, selectedAnimalType, diagnoses, activityData,
      selectedDuration, selectedIntensity, dietRangesData
    } = this.props;

    if (window.showDebug){
      // console.log("speciesId:" + speciesId);
      // console.log("birth:" + birth);
      console.log("pregnancyId:" + pregnancyId);
      // console.log("lactationId:" + lactationId);
      // console.log("derData:" + derData);
      // console.log("dataMapping,:" + dataMapping);
      console.log("selectedBreedData:");
      console.log(selectedBreedData);
      // console.log("selectedAnimalType:" + selectedAnimalType);
      console.log("diagnoses:" + diagnoses);
      console.log("activityData:");
      console.log(activityData);
      console.log("selectedDuration:" + selectedDuration);
      console.log("selectedIntensity:" + selectedIntensity);
    }

    let points = 0;
    let pointsReportData = {
      "Indications" : [],
    };

    const isVeterinaryDietProduct = dietRangesData[selectedAnimalType].filter(diet => diet.isVetDiet)[0].id === product.ranges[0]

    // 1) POINTS FOR LIFE STAGE
    const birthDate = moment(birth, 'DD/MM/YYYY').toDate();
    const weeksAge = () => Math.floor((new Date() - birthDate) / 604800000)
    let hasClaimedLifeStage = false;

    if (window.showDebug){
      console.log("derData:");
      console.log(derData);
    }

    // Loop this products lifestage data
    if (window.showDebug){
      console.log("product");
      console.log(product);
    }

    let index = 0;

    product.lifeStages.forEach(lifeStage => {
      const lifeStageData = dataMapping.data[lifeStage];

      if (window.showDebug){
        console.log("lifeStageData:");
        console.log(lifeStageData);
      }

      // Life Stage
      if (lifeStageData.lifeStage != null && lifeStageData.lifeStage.toLowerCase().replace(/_/g, ' ') == derData.lifeStage){

        if (!hasClaimedLifeStage){
          points += 1;
          pointsReportData['Life Stage (' + lifeStageData.lifeStage + ')' + index] = 1;
          hasClaimedLifeStage = true;
        }
      }

      // Pregnancy
      if (lifeStageData.pregnancy == "1" && pregnancyId != null){
        points += 1.5;
        pointsReportData['Pregnancy' + index] = 1.5;
      }

      // Lactation
      if(lifeStageData.lactation == "1" && lactationId != null){
        points += 1.5;
        pointsReportData['Lactation ' + index] = 1.5;
      }
      index++;
    });

    // Indications
    index = 0;
    product.indications.forEach(productIndication => {
      // For each matching indication add 1 point
      diagnoses.forEach(selectedDiagnoses => {
        if (selectedDiagnoses == productIndication){
          points+= 2;
          pointsReportData['Indications'].push('Diagnosis ' + index + selectedDiagnoses, 2);
        }
      });
    });

    // Breed
    // selectedBreedData contains the data for the selected breed from the form
    // Give points for the specific breed (eg: pug)
    if(product.breed[selectedAnimalType].includes(selectedBreedData.id) > 0) {
      points += 0.5;
      pointsReportData['Breed'] = 0.5;
    }

    // Give points for the breed size (eg: Large Robust)
    if(product.breed[selectedAnimalType].includes(selectedBreedData.sizeId) > 0) {
      points += 0.5;
      pointsReportData['Breed Size'] = 0.5;
    }

    // Activity
    const activityIndications = activityData.data[selectedAnimalType][selectedDuration][selectedIntensity]
    if (window.showDebug){
      console.log(activityIndications);
    }
    if(activityIndications){
      let tempPoints = Underscore.intersection(activityIndications, product.indications).length;
      points+= tempPoints;
      pointsReportData['Activity'] = tempPoints;
    }

    //Veterinary diet products and no diagnoses selected
    if (!diagnoses.length && isVeterinaryDietProduct)  {
      points -= 2.5;
      pointsReportData['Veterinary Diet/No diagnoses'] = -2.5;
    } else if (diagnoses.length && !pointsReportData['Indications'].length && isVeterinaryDietProduct) {
      points -= 1.5;
      pointsReportData['Veterinary Diet/No matching diagnoses'] = -1.5;
    }

    if (window.showDebug){
      console.warn("points: " + points)
    }

    // Return either the points or the pointsReportData depending on the mode
    return pointsReport ? pointsReportData : points;
  }

  /**
   * Order by points
   */
  getOrderedProducts(products){
    let that = this;
    products.map(function(product) {
      product.points = that.getPoints(product, false);
      product.pointsDetails = JSON.stringify(that.getPoints(product, true), null, ' ');

      if(product.points > 2){
        product.class = "nppe2-fc-best";
      }
      else if(product.isSticky){
        product.class = "nppe2-fc-pinned";
        product.points = 2.9; // Add points
      }
      else{
        product.class = "nppe2-fc-available";
      }
    });
    return products.sort(function(a, b) {
      return b.points - a.points;
    });
  }

  /**
   * Return types of available products
   */
  getAvailableFoodTypes() {
    const availableFoodTypes = [];
    const foodTypes = [
      productTypes.DRY_FOOD,
      productTypes.WET_FOOD,
      productTypes.RELATED,
      productTypes.SNACKS
    ];

    foodTypes.forEach((foodType) => {
      const filteredProducts = this.getFilteredProducts(foodType);
      const quantityRecommendedProducts = this.getOrderedProducts(filteredProducts).filter((product) => product.points > 2);

      if (filteredProducts.length) availableFoodTypes.push({
        "foodType": foodType,
        "quantityRecommendedProducts": quantityRecommendedProducts
      });
    });

    return availableFoodTypes;
  }

  /**
   * Render
   */
  render() {
    const {data, error, pending, ready, readyDiet, readyAnimalType,
      selectedAnimalType, defaultValues, onSelect, onSelectCategory,
      selectedCategory, selected, onRemove, selectedData, pendingMapping,
      readyDailyIntake, activityData, openModalWithContent, availableCategories,
      setAvailableCategories
    } = this.props;

    // If Animal type data is pending
    if(pending || !ready || pendingMapping || !selectedAnimalType || !activityData) return (
      <Loader/>
    );

    // If there is a need for default data
    if(!ready && !error && !pending && readyDiet && readyAnimalType && !pendingMapping && readyDailyIntake)  {
      defaultValues(selectedAnimalType);
    }

    // Get products
    let products = this.getFilteredProducts();
    // Get ordered products
    products = this.getOrderedProducts(products);
    // Greyed computation
    const greyed = this.getGreyed();
    // Get available food types
    const availableFoodTypes = this.getAvailableFoodTypes();

    if (availableFoodTypes.length !== availableCategories.length) {
      setAvailableCategories(availableFoodTypes.map((item) => item.foodType));
    };

    // Return switcher
    return (
      <div className='nppe2-fc-product-switcher__wrapper'>
        {error && <span className='nppe2-fc-diet-switcher__error'>{error}</span>}
        {!error &&
        <ProductsSwitcher
            data={data}
            products={products}
            selected={selected}
            selectedCategory={selectedCategory}
            onSelect={onSelect}
            onSelectCategory={onSelectCategory}
            onRemove={onRemove}
            greyed={greyed}
            openModalWithContent={openModalWithContent}
            availableFoodTypes={availableFoodTypes}
        />}
        {!error &&
        <ProductCardsRemover selectedData={selectedData} onRemove={onRemove}/>}
      </div>
    );
  }
}

const mapStateToProps = state => {

  return {
    selected: state.productsReducer.selected,
    selectedData: state.productsReducer.selectedData,
    selectedCategory: state.productsReducer.selectedCategory,
    availableCategories: state.productsReducer.availableCategories,
    error: state.productsReducer.error,
    data: state.productsReducer.data,
    dataMapping: state.lifeStageMappingReducer.data,
    pending: state.productsReducer.pending,
    ready: state.productsReducer.ready,
    pendingMapping: state.lifeStageMappingReducer.pending,
    readyAnimalType: state.animalTypeReducer.ready,
    selectedAnimalType: state.animalTypeReducer.animalType,
    readyBreed: state.breedReducer.ready,
    selectedBreedData: state.breedReducer.selectedData,
    breed: state.productsReducer.breed,
    readyDiet: state.dietReducer.ready,
    selectedDietData: state.dietReducer.selectedData,
    selectedDiet: state.dietReducer.selected,
    dietRangesData: state.dietReducer.data.data,
    diet: state.productsReducer.diet,
    // Ordering
    readyDailyIntake: state.dailyIntakeReducer.ready,
    speciesId: state.animalTypeReducer.selectedId,
    birth: state.birthDateReducer.selected,
    pregnancyId: state.weeksLitterReducer.pregnancyFactorId,
    lactationId: state.weeksLitterReducer.lactationFactorId,
    derData: state.calculateDerReducer.data,
    diagnoses: state.diagnosesReducer.selectedIds,
    activityData: state.physicalActivityReducer.data,
    selectedDuration: state.physicalActivityReducer.selectedDuration,
    selectedIntensity: state.physicalActivityReducer.selectedIntensity,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators({
      fetchData: fetchProductsAction,
      fetchMappingData: fetchLifeStageMappingAction
    }, dispatch),
    onSelect: (id, product) => dispatch({
      type: actionTypes.SELECT,
      selected: id,
      selectedData: product,
    }),
    onSelectCategory: (id) => dispatch({
      type: actionTypes.SELECT_CATEGORY,
      selectedCategory: id,
    }),
    onRemove: (id) => dispatch({
      type: actionTypes.REMOVE,
      removed: id,
    }),
    setAvailableCategories: (availableCategories) => dispatch({
      type: actionTypes.AVAILABLE_CATEGORIES,
      availableCategories: availableCategories,
    }),
    defaultValues: (animalType) => dispatch({
      type: actionTypes.DEFAULT,
      animalType: animalType,
    }),
    openModalWithContent: (key) => dispatch({
      type: helpActionTypes.OPEN_MODAL_WITH_CONTENT,
      key: key,
      open: true,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Products);
